import React, { useState, useEffect } from "react";
import logo from "../../assets/EUROFINS_TRACKING_LOGO_RZ_DNA_Patho_Tracker_pos.jpg";
import landingImage from "../../assets/landingPage-background.png";
import "./landingPage.css";
import { Col, Button } from "reactstrap";
import { useMsal } from "../../msal-context";
import { Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../AppInsights";
import { Image } from "react-bootstrap";
import Row from "reactstrap/lib/Row";
import {
  Input,
} from 'reactstrap';

const LandingPage = (props) => {
  const { login, getToken, isAuthenticated, extLogin } = useMsal();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [loginModal, setLoginModal] = useState(true)
  const [loginPage, setLoginPage] = useState(false)
  const [username, setUserName] = useState(localStorage.getItem('mail') == null || localStorage.getItem('mail').length == 0 ? '' : localStorage.getItem('mail'))
  const [password, setPassword] = useState('')

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  useEffect(() => {
    let user = {};
    if (localStorage.getItem("userInfo")) {
      user = jwt_decode(localStorage.getItem("userInfo"));
      if (!localStorage.getItem("auth_token")) getToken(props.apiRequest, user);
    }
  }, [isAuthenticated, getToken, props.apiRequest]);

  const checkAuth = () => {
    if (
      (localStorage.getItem("auth_token") &&
        localStorage.getItem("auth_token") !== null) ||
      localStorage.getItem("guest")
    )
      return true;
    else return false;
  };

  function ValidateEmail(mail) {
    localStorage.setItem('mail', mail)
    mail = mail.trim()
    if (String(mail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      return (true)
    }
    return (false)
  }

  function usernameCheck(username) {
    let user = username.toLowerCase()

    props.loginRequest.loginHint = username
    if (user != undefined || user != null) {
      let user_split = user.split('@')[1]  //should contain domain name
      if (user_split != undefined || user_split != null) {
        if (
          user_split.includes('azgenomics') ||
          user_split.includes('it.eurofinseu.com') ||   // fix: era == agora é .includes()
          user_split.includes('onmicrosoft') ||
          user_split.includes('bblims') ||
          user_split.includes('eurofinslatam.com')       // adicionado domínio LATAM
        ) {
          return true
        }
        return false
      }
      return false
    }
    return false
  }

  return checkAuth() ? (
    <Redirect to={windowWidth > 600 ? "/dashboard/" : "/samples/addsamples/"} />
  ) : (
    <div className="d-grid">
      <>
        <body className="landing-page-body">
          <Image
            src={landingImage}
            className="landingpage-background"
            responsive
          />
          <Col className="landingpage-content" md={6}>
            <Row className="welcome-text center-block text-center">
              Welcome to
            </Row>
            <Row className="dna-text center-block text-center">
              DNA PathoTracker<sup className="sup-tm-lp">TM</sup>
            </Row>
            <Row className="solution-text">
              Your Solution For Tracking Analytical Results of Samples
            </Row>
            <Row className="email-login">
              <Input onChange={(event) => { setUserName(event.target.value); }} className="email-input-field remove-margin width-input-email" type="text" name="username" id="username" value={username} size="1" placeholder="Please enter your Email ID" />
            </Row>
            <Row>
              {!isAuthenticated ? (
                <Button
                  id="getStarted"
                  href={
                    usernameCheck(username)
                      ?
                      null : '/extlogin'
                  }
                  className="view-toggle-button get-started-text"
                  onClick={() => {
                    usernameCheck(username) ?
                      login(props.loginRequest, "loginRedirect")
                      : setLoginPage()
                  }}
                  disabled={ValidateEmail(username) ? false : true}
                >
                  Login
                </Button>
              ) : (
                <Button
                  id="getStarted"
                  className="view-toggle-button get-started-text"
                  href="/dashboard/"
                >
                  GET STARTED
                </Button>
              )}
              {!isAuthenticated ? (
                <Button
                  id="getStarted"
                  onClick={() => {
                    localStorage.setItem("guest", true);
                    sessionStorage.setItem("building", "BldgA");
                    sessionStorage.setItem("floor", 20000);
                    sessionStorage.setItem("buildingId", 20000);
                    sessionStorage.setItem("buildingName", "Building A");
                    sessionStorage.setItem("floorId", 20000);
                    sessionStorage.setItem("floorName", "Floor A");
                  }}
                  className="view-toggle-button get-started-text"
                  href={windowWidth > 450 ? "/dashboard/" : "/samples/"}
                >
                  Guest Login
                </Button>
              ) : null}
              {!isAuthenticated ? (
                <Button
                  id="getStarted"
                  onClick={() => {
                    localStorage.setItem("guest", true);
                    localStorage.setItem("species", true);
                    sessionStorage.setItem("building", "BldgA");
                    sessionStorage.setItem("floor", 20000);
                    sessionStorage.setItem("buildingId", 20000);
                    sessionStorage.setItem("buildingName", "Building A");
                    sessionStorage.setItem("floorId", 20000);
                    sessionStorage.setItem("floorName", "Floor A");
                  }}
                  className="view-toggle-button get-started-text"
                  href={windowWidth > 450 ? "/dashboard/" : "/samples/"}
                >
                  Environment testing
                </Button>
              ) : null}
            </Row>
          </Col>
        </body>
        <footer>
          <Row className="landingpage-logo">
            <Image className="landingpage-image" src={logo} responsive />
          </Row>
          {/* <div className="footer">© Eurofins Genomics 2020</div> */}
        </footer>
      </>
    </div>
  );
};

export default withAITracking(
  reactPlugin,
  LandingPage,
  "Landing Page",
  "LandingPage"
);